// @ts-check
/**
 * Pruh výběru místa (sekce 3 R-23 a, FR-3-63; prototyp regionBar ř. 806–829 a přepnutí
 * ř. 2157). Kořen `[data-module="place-bar"]` (components/place-bar.gohtml) nese tlačítka
 * `button[data-panel][aria-controls]` a panely s `id` z `aria-controls`; server vykreslí výchozí
 * otevřený panel (`aria-expanded="true"`, panel bez `hidden`) a ostatní panely `hidden` — bez JS
 * je pruh použitelný jako HTML (čipy jsou odkazy).
 *
 * S JS modul deleguje `click` na kořeni: klik na tlačítko otevře jeho panel a zavře ostatní
 * (právě jeden otevřený), druhý klik na totéž tlačítko panel zavře, tlačítko
 * s `aria-disabled="true"` (Okresy bez kraje, Obce bez okresu; ui-checklist bod 9) nereaguje.
 * Přepnutí mění jen `aria-expanded` a `hidden` — vzhled otevřeného tlačítka dává varianta
 * `aria-expanded:` v šabloně, třídy se nemění. Fokus zůstává na tlačítku
 * (`focus({ preventScroll: true })` — Safari fokus kliknutím nedává). Stav pruhu není v URL
 * (přechodný jako zásuvka, R-23 a); žádný `fetch`, časovač ani texty.
 */

/** Tlačítka panelů uvnitř kořene. */
const BUTTON = 'button[data-panel][aria-controls]';

/**
 * Inicializace modulu nad kořenem `[data-module="place-bar"]`.
 * @param {HTMLElement} root
 */
export default function init(root) {
  const doc = root.ownerDocument;
  const win = /** @type {Window & typeof globalThis} */ (doc.defaultView ?? globalThis);

  /** Panel tlačítka podle `aria-controls`; mimo kořen = žádný. @param {Element} button */
  function panelOf(button) {
    const id = button.getAttribute('aria-controls');
    const panel = id ? doc.getElementById(id) : null;
    return panel !== null && root.contains(panel) ? panel : null;
  }

  /** @param {Element} button @param {boolean} open */
  function set(button, open) {
    button.setAttribute('aria-expanded', String(open));
    const panel = panelOf(button);
    if (panel !== null) panel.hidden = !open;
  }

  root.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof win.Element)) return;
    const button = target.closest(BUTTON);
    if (!(button instanceof win.HTMLButtonElement) || !root.contains(button)) return;
    if (button.getAttribute('aria-disabled') === 'true') return;
    const open = button.getAttribute('aria-expanded') !== 'true';
    for (const other of root.querySelectorAll(BUTTON)) set(other, other === button && open);
    button.focus({ preventScroll: true });
  });
}
